import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import LogInModal from 'flarum/forum/components/LogInModal';
import LogInButtons from 'flarum/forum/components/LogInButtons';
import { extend, override } from 'flarum/common/extend';

app.initializers.add('asaa-sso', () => {
  override(LogInModal.prototype, 'body', function () {
    return <LogInButtons />;
  });

  override(LogInModal.prototype, 'footer', function () {
    return null;
  });

  extend(HeaderSecondary.prototype, 'items', function (items) {
    items.remove('signUp');

    if (app.session.user && app.forum.attribute('asaaAuthUrl')) {
      items.add(
        'asaaPortal',
        <Button
        className="Button Button--link"
        icon="fas fa-home"
        onclick={() => {
          window.location.href = app.forum.attribute('asaaAuthUrl');
        }}
        >
        Portalen
        </Button>,
        15
      );
    }
  });
});
